import { Permission, alphabeticalSort } from '@cims-online/shared'
import { useCheckPermission } from 'hooks/useCheckPermission'
import { useConcreteTestSetTrackerContext } from '../../../../ConcreteTestSetTrackerContext'
import { useSetDocumentChecklistValueMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleSuccessNotification } from 'hooks/notificationHandler'
import CIMSChecklist from 'components/CIMSChecklist'
import { ConcreteTestSet } from '../../../../ConcreteTestSetTrackerContext/types'

const DocumentChecklistCheckboxes: React.FC<ConcreteTestSet> = ({
  documentChecklistValues,
  globalId,
  concreteMaterial,
  testSetId,
}) => {
  const {
    testSets: { refetch },
    documentChecklistItems,
  } = useConcreteTestSetTrackerContext()
  const canCheck = useCheckPermission(
    Permission.EditAssociatedDocumentChecklistItem
  )
  const [set] = useSetDocumentChecklistValueMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      setDocumentChecklistValue: {
        documentChecklistValue: {
          documentChecklistItem: { name },
        },
      },
    }) =>
      simpleSuccessNotification(
        `${name} successfully checked for ${testSetId}!`
      ),
  })
  return (
    <CIMSChecklist
      items={documentChecklistItems
        ?.reduce((items, item) => {
          if (
            item.documentChecklistItemToConcreteMaterials.some(
              ({ concreteMaterial: { placementType } }) =>
                placementType === concreteMaterial?.placementType
            )
          )
            items.push(item)
          return items
        }, Array<(typeof documentChecklistItems)[0]>())
        .sort(alphabeticalSort('name'))
        .map(({ id, name }) => {
          const checked = documentChecklistValues?.find(
            ({ checked, documentChecklistItem }) =>
              checked && documentChecklistItem.id === id
          )?.checked
          return {
            key: `${globalId}_${id}`,
            tag: { children: name },
            checked,
            onChange: async () => {
              if (!canCheck) return
              await set({
                variables: {
                  input: {
                    checked: !checked,
                    documentChecklistItemId: id,
                    concreteTestSetId: globalId,
                  },
                },
              })
              await refetch()
            },
          }
        })}
    />
  )
}

export default DocumentChecklistCheckboxes
